export const MOCK_IPS_RESPONSE = {
  results: [
    {
      id: 'mock-ip-1',
      ip: '93.184.216.34',
      score: 'B',
      loc: 'US, Norwell',
      timestamp: '2024-11-15T09:45:00Z',
      timestamp_jalali: '1403/08/25 09:45',
      ports: [80, 443],
      vulnerabilities: { critical: 1, high: 1, medium: 2, low: 0, info: 0 },
    },
    {
      id: 'mock-ip-2',
      ip: '104.21.45.78',
      score: 'A',
      loc: 'US, San Francisco',
      timestamp: '2024-11-15T09:50:00Z',
      timestamp_jalali: '1403/08/25 09:50',
      ports: [443],
      vulnerabilities: { critical: 0, high: 0, medium: 1, low: 0, info: 0 },
    },
    {
      id: 'mock-ip-3',
      ip: '172.67.182.55',
      score: 'C',
      loc: 'GB, London',
      timestamp: '2024-11-15T09:55:00Z',
      timestamp_jalali: '1403/08/25 09:55',
      ports: [80, 443, 8080],
      vulnerabilities: { critical: 0, high: 2, medium: 3, low: 1, info: 0 },
    },
  ],
  current_page: 1,
  total_pages: 1,
}

export const MOCK_IP_FILTER_OPTIONS = {
  score: ['A', 'B', 'C', 'D', 'F'],
  ports: [80, 443, 8080],
}

export const MOCK_IP_DETAIL = {
  id: 'mock-ip-1',
  ip: '93.184.216.34',
  version: 'ipv4',
  score: 'B',
  ssl: { score: 'A' },
  scan_list: [{ id: 'mock-scan-1', label: '2024-11-15' }],
  selected_scan: 'mock-scan-1',
  vulnerabilities: { critical: 1, high: 1, medium: 2, low: 0, info: 0 },
  total_vulnerabilities: 4,
  // Same shape fix as mockAssets: `[]` is not an empty trend, it is a wrong-shaped
  // one, and the IP detail chart degraded to its placeholder because of it.
  vulnerabilities_over_time: {
    x: ['2024-11-11', '2024-11-12', '2024-11-13', '2024-11-14', '2024-11-15'],
    new: [1, 1, 0, 2, 0],
    closed: [0, 0, 1, 0, 1],
  },
  vulnerabilities_list: [],
  domains: ['example.com', 'www.example.com'],
  // The Asset Insights hero sentence reads this for its PTR segment.
  host_domain: 'edge1.example.net',
  loc: 'US, Norwell',
  latitude: 42.16,
  longitude: -70.82,
  asn: 'AS15133',
  asn_name: 'MCI Communications Services',
  asn_domain: 'verizon.com',
  cidr: '93.184.216.0/24',
  techs: [{ name: 'Nginx', version: '1.24.0' }],
  screenshots: [],
  ports: [{ port: 80, protocol: 'tcp', service: 'http' }, { port: 443, protocol: 'tcp', service: 'https' }],
  // A declared valuation — addresses are valued independently of the domains
  // that resolve to them, so this differs deliberately from the host's.
  value: {
    criticality: 'medium',
    owner: 'Network Operations',
    environment: 'production',
    data_classification: 'internal',
    notes: 'Shared edge IP behind the CDN — hosts several marketing domains.',
    updated_by: { id: 'mock-user-1', email: 'demo@example.com' },
    updated_at: '2024-11-09T08:00:00Z',
    created_at: '2024-10-01T08:00:00Z',
  },
}
